import { Checkbox, FormControlLabel } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  marginBottom: 6,
  width: "100%",
  padding: "10px 0",
  "& > span": {
    padding: 0,
    marginRight: 7
  }
})

export const StyledCheckBox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.grey["300"]
}))
